import React from "react";
import ReactDOM from "react-dom/client";
 // أو App.js
import { Provider } from "react-redux";
import { store } from "./redux/store";

import'./index.css';
import App from "./App";
import { BrowserRouter } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
